import React, { useEffect, useState } from "react";
import axios from "../../../../http/axios";
import moment from "moment";

import { faCircle } from "@fortawesome/free-regular-svg-icons";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { store, useGlobalState } from "state-pool";
import SlotOption from "./SlotOption";

const SessionField = (props) => {
  const [session1, setSession1] = useState(null);
  const [session2, setSession2] = useState(null);
  const [session3, setSession3] = useState(null);
  let [sessions, setSessions] = useState([]);

  const [sessionError1, setSessionError1, updateSessionError1] =
    useGlobalState("sessionError1");

  const [sessionError2, setSessionError2, updateSessionError2] =
    useGlobalState("sessionError2");

  const [sessionError3, setSessionError3, updateSessionError3] =
    useGlobalState("sessionError3");

  let sessionChangeCounter = 0;

  const buildSessionOptions = (rawSessions = []) => {
    const result = [];
    rawSessions.forEach((s) => {
      const base = {
        ...s,
        sessionId: s.id,
        optionId: String(s.id),
        location:
          s.locationEntity?.name ||
          s.locationName ||
          '',
        variant: null,
      };

      if (s.isDoubleLocation) {
        result.push({
          ...base,
          optionId: `${s.id}-AM`,
          variant: 'AM',
          location:
            s.locationEntity?.name ||
            s.locationName ||
            '',
        });
        result.push({
          ...base,
          optionId: `${s.id}-PM`,
          variant: 'PM',
          location:
            s.secondLocationEntity?.name ||
            s.secondLocationName ||
            s.locationName ||
            '',
        });
      } else {
        result.push(base);
      }
    });
    return result;
  };

  useEffect(() => {
    if (props.sessions?.length) {
      setSessions(buildSessionOptions(props.sessions));
    }
  }, [props.sessions]);

  useEffect(() => {
    let initialSessionsValues = props.input.value;

    if (initialSessionsValues?.length) {
      let pickedFirstSession;
      let pickedSecondSession;
      let pickedThirdSession;

      let theFirstSession = initialSessionsValues[0];
      let theSecondSession;
      let theThirdSession;

      for (let i = 0; i < initialSessionsValues.length; ++i) {
        if (initialSessionsValues[i].id !== theFirstSession.id) {
          if (
            theSecondSession &&
            initialSessionsValues[i].id !== theSecondSession.id
          ) {
            theThirdSession = initialSessionsValues[i];
          } else {
            theSecondSession = initialSessionsValues[i];
          }
        }
      }

      let firsSessionSlots = [];
      let secondSessionSlots = [];
      let thirdSessionSlots = [];
      initialSessionsValues.forEach((slot) => {
        if (slot.id === theFirstSession.id) {
          firsSessionSlots.push(slot);
        }
        if (theSecondSession && slot.id === theSecondSession.id) {
          secondSessionSlots.push(slot);
        }
        if (theThirdSession && slot.id === theThirdSession.id) {
          thirdSessionSlots.push(slot);
        }
      });

      initialSessionsValues = [
        firsSessionSlots,
        secondSessionSlots,
        thirdSessionSlots,
      ];

      initialSessionsValues.forEach((item) => {
        if (item === undefined || item.length === 0) {
          initialSessionsValues.splice(initialSessionsValues.indexOf(item), 1);
        }
      });

      if (Array.isArray(initialSessionsValues[0])) {
        pickedFirstSession = sessions.filter(
          (session) => initialSessionsValues[0][0].id === session.id
        );
      } else {
        pickedFirstSession = sessions.filter(
          (session) => initialSessionsValues[0].id === session.id
        );
      }

      if (initialSessionsValues[1]) {
        if (
          Array.isArray(initialSessionsValues[1]) &&
          initialSessionsValues[1].length > 0
        ) {
          pickedSecondSession = sessions.filter(
            (session) => initialSessionsValues[1][0].id === session.id
          );
        } else {
          pickedSecondSession = sessions.filter(
            (session) => initialSessionsValues[1].id === session.id
          );
        }
      }

      if (initialSessionsValues[2]) {
        if (
          Array.isArray(initialSessionsValues[2]) &&
          initialSessionsValues[2].length > 0
        ) {
          pickedThirdSession = sessions.filter(
            (session) => initialSessionsValues[2][0].id === session.id
          );
        } else {
          pickedThirdSession = sessions.filter(
            (session) => initialSessionsValues[2].id === session.id
          );
        }
      }

      if (pickedFirstSession && pickedFirstSession[0]?.id) {
        setSession1(pickedFirstSession[0]);
        fetchSlots(pickedFirstSession[0].id, "session1", pickedFirstSession[0].variant);
      }
      if (pickedSecondSession && pickedSecondSession[0]?.id) {
        setSession2(pickedSecondSession[0]);
        fetchSlots(pickedSecondSession[0].id, "session2", pickedSecondSession[0].variant);
      }
      if (pickedThirdSession && pickedThirdSession[0]?.id) {
        setSession3(pickedThirdSession[0]);
        fetchSlots(pickedThirdSession[0].id, "session3", pickedThirdSession[0].variant);
      }
    }
  }, [sessions]);

  useEffect(() => {
    const res = [];

    if (!session1?.id) {
      setSessionError1(false);
    }
    if (!session2?.id) {
      setSessionError2(false);
    }
    if (!session3?.id) {
      setSessionError3(false);
    }

    if (session1?.id) {
      const pref = 1;

      if (session1.slots?.length) {
        const selectedSlots = session1.slots?.filter(
          (el) => el.isSelected === true
        );
        if (selectedSlots.length > 0) {
          selectedSlots.forEach((s) => {
            res.push(mapSlot(s, session1, pref));
          });
        } else {
          res.push(mapSlot(null, session1, pref));
        }
      }
    }
    if (session2?.id) {
      const pref = 2;

      if (session2.slots?.length) {
        const selectedSlots = session2.slots?.filter(
          (el) => el.isSelected === true
        );
        if (selectedSlots.length > 0) {
          selectedSlots.forEach((s) => {
            res.push(mapSlot(s, session2, pref));
          });
        } else {
          res.push(mapSlot(null, session2, pref));
        }
      }
    }

    if (session3?.id) {
      const pref = 3;
      if (session3.slots?.length) {
        const selectedSlots = session3.slots?.filter(
          (el) => el.isSelected === true
        );
        if (selectedSlots.length > 0) {
          selectedSlots.forEach((s) => {
            res.push(mapSlot(s, session3, pref));
          });
        } else {
          res.push(mapSlot(null, session3, pref));
        }
      }
    }
    props.input.onChange(res);
  }, [session1, session2, session3]);

  const mapSlot = (slot, session, preference) => {
    let time = "";
    let d1 = getDateLabel(session.fromDate);
    let d2 = getDateLabel(session.toDate);
    if (slot) {
      const slotTimeStr = slot.fromTimeResolved
        ? `${slot.fromTimeResolved} - ${slot.toTimeResolved}`
        : "";
      time = slot.fromTimeResolved ? `${d1} - ${d2} ${slotTimeStr}` : null;
    } else {
      time = `${d1} - ${d2}`;
    }
    return {
      id: session.sessionId || session.id,
      sessionId: session.sessionId || session.id,
      sessiontime: time,
      sessionname: `${d1} - ${d2} ${session.location}${session.variant ? ' (' + session.variant + ')' : ''}`,
      location: session.location,
      variant: session.variant,
      preference: preference,
      sessTimeId: slot ? slot.id : null,
      notes: slot ? slot.notes : null,
    };
  };

  const getDateLabel = (dateStr) => {
    if (dateStr === null) {
      return "Jan 01";
    }
    return moment(dateStr).format("MMM DD");
  };

  const checkIsSelected = (optionId) => {
    return (
      session1?.optionId === optionId ||
      session2?.optionId === optionId ||
      session3?.optionId === optionId
    );
  };

  const valueChange = (e) => {
    ++sessionChangeCounter;
    const key = e.target.name;
    const id = e.target.value;
    const session = { ...sessions.find((el) => (el.optionId || String(el.id)) === id) };
    if (session.id) {
      if (key === "session1") {
        session.slots = [];

        setSession1(session);
      }
      if (key === "session2") {
        session.slots = [];
        setSession2(session);
      }
      if (key === "session3") {
        session.slots = [];
        setSession3(session);
      }
      fetchSlots(session.sessionId || id, key, session.variant);
    } else {
      // CLEAR was selected - clear both the session and the error
      if (key === "session1") {
        setSession1(null);
        setSessionError1(false);
      }
      if (key === "session2") {
        setSession2(null);
        setSessionError2(false);
      }
      if (key === "session3") {
        setSession3(null);
        setSessionError3(false);
      }
    }
  };

  const filterByVariant = (slots, variant) => {
    if (!variant) {
      return slots;
    }
    return slots.filter((slot) => {
      const timeStr = slot.fromTimeResolved || slot.fromTime;
      if (!timeStr) return true;
      const parsed = new Date(`1970/01/01 ${timeStr}`);
      return variant === 'PM' ? parsed.getHours() >= 13 : parsed.getHours() < 13;
    });
  };

  const fetchSlots = (id, key, variant) => {
    axios
      .get(`/public/sessions/${id}/session-times`)
      .then((r) => {
        const filteredResponse = filterByVariant(r.data, variant);
        if (key === "session1") {
          setSession1((prev) => {
            let initialSessionsValues = props.input.value;

            if (initialSessionsValues?.length) {
              let theFirstSession = initialSessionsValues[0];
              let theSecondSession;
              let theThirdSession;

              for (let i = 0; i < initialSessionsValues.length; ++i) {
                if (initialSessionsValues[i].id !== theFirstSession.id) {
                  if (
                    theSecondSession &&
                    initialSessionsValues[i].id !== theSecondSession.id
                  ) {
                    theThirdSession = initialSessionsValues[i];
                  } else {
                    theSecondSession = initialSessionsValues[i];
                  }
                }
              }

              let firsSessionSlots = [];
              let secondSessionSlots = [];
              let thirdSessionSlots = [];
              initialSessionsValues.forEach((slot) => {
                if (slot.id === theFirstSession.id) {
                  firsSessionSlots.push(slot);
                }
                if (theSecondSession && slot.id === theSecondSession.id) {
                  secondSessionSlots.push(slot);
                }
                if (theThirdSession && slot.id === theThirdSession.id) {
                  thirdSessionSlots.push(slot);
                }
              });

              initialSessionsValues = [
                firsSessionSlots,
                secondSessionSlots,
                thirdSessionSlots,
              ];

              initialSessionsValues.forEach((item) => {
                if (item === undefined || item.length === 0) {
                  initialSessionsValues.splice(
                    initialSessionsValues.indexOf(item),
                    1
                  );
                }
              });
            }

            if (initialSessionsValues?.length) {
              let pickedValue = Object.assign({}, prev, { slots: r.data });
                pickedValue.slots = filterByVariant(pickedValue.slots, variant);
              let initialValuesSessionTimes = [];
              if (Array.isArray(initialSessionsValues[0])) {
                initialSessionsValues[0].forEach((session) => {
                  if (Array.isArray(session)) {
                    session.forEach((elem) => {
                      initialValuesSessionTimes.push(
                        elem.sessiontime.split(" ").splice(5, 6).join("")
                      );
                    });
                  } else if (!session.sessiontime && session.notes) {
                    initialValuesSessionTimes.push(session.notes);
                  } else {
                    session.sessiontime &&
                      initialValuesSessionTimes.push(
                        session.sessiontime.split(" ").splice(5, 6).join("")
                      );
                  }
                });
              } else {
                initialValuesSessionTimes.push(
                  initialSessionsValues[0].sessiontime
                    .split(" ")
                    .splice(5, 6)
                    .join("")
                );
              }
              pickedValue.slots.forEach((slot) => {
                if (!slot.fromTimeResolved && slot.fromTime) {
                  const array = slot.fromTime.split(":");
                  array.splice(array.indexOf("00"), 1);
                  slot.fromTimeResolved = array.join(":");
                }
                if (
                  (slot.fromTimeResolved &&
                    initialValuesSessionTimes.includes(
                      slot.fromTimeResolved.split(" ").join("") +
                        "-" +
                        slot.toTimeResolved.split(" ").join("")
                    ) &&
                    initialSessionsValues.flat(Infinity)[0].preference === 1 &&
                    sessionChangeCounter < 1) ||
                  (!slot.fromTimeResolved &&
                    initialValuesSessionTimes.includes(slot.notes) &&
                    sessionChangeCounter < 1)
                ) {
                  slot.isSelected = true;
                }
              });
              return pickedValue;
            } else {
              return Object.assign({}, prev, { slots: filteredResponse });
            }
          });
        }
        if (key === "session2") {
          setSession2((prev) => {
            let initialSessionsValues = props.input.value;
            if (initialSessionsValues?.length) {
              let theFirstSession = initialSessionsValues[0];
              let theSecondSession;
              let theThirdSession;

              for (let i = 0; i < initialSessionsValues.length; ++i) {
                if (initialSessionsValues[i].id !== theFirstSession.id) {
                  if (
                    theSecondSession &&
                    initialSessionsValues[i].id !== theSecondSession.id
                  ) {
                    theThirdSession = initialSessionsValues[i];
                  } else {
                    theSecondSession = initialSessionsValues[i];
                  }
                }
              }

              let firsSessionSlots = [];
              let secondSessionSlots = [];
              let thirdSessionSlots = [];

              initialSessionsValues.forEach((slot) => {
                if (slot.id === theFirstSession.id) {
                  firsSessionSlots.push(slot);
                }
                if (theSecondSession && slot.id === theSecondSession.id) {
                  secondSessionSlots.push(slot);
                }
                if (theThirdSession && slot.id === theThirdSession.id) {
                  thirdSessionSlots.push(slot);
                }
              });

              initialSessionsValues = [
                firsSessionSlots,
                secondSessionSlots,
                thirdSessionSlots,
              ];

              initialSessionsValues.forEach((item) => {
                if (item === undefined || item.length === 0) {
                  initialSessionsValues.splice(
                    initialSessionsValues.indexOf(item),
                    1
                  );
                }
              });
            }

            if (initialSessionsValues[1]) {
              let pickedValue = Object.assign({}, prev, { slots: filteredResponse });
              let initialValuesSessionTimes = [];
              if (Array.isArray(initialSessionsValues[1])) {
                initialSessionsValues[1].forEach((session) => {
                  if (session.sessiontime) {
                    initialValuesSessionTimes.push(
                      session.sessiontime.split(" ").splice(5, 6).join("")
                    );
                  } else if (!session.sessiontime && session.notes) {
                    initialValuesSessionTimes.push(session.notes);
                  }
                });
              } else {
                initialValuesSessionTimes.push(
                  initialSessionsValues[1].sessiontime
                    .split(" ")
                    .splice(5, 6)
                    .join("")
                );
              }
              pickedValue.slots.forEach((slot) => {
                if (!slot.fromTimeResolved && slot.fromTime) {
                  const array = slot.fromTime.split(":");
                  array.splice(array.indexOf("00"), 1);
                  slot.fromTimeResolved = array.join(":");
                }
                if (
                  (slot.fromTimeResolved &&
                    initialValuesSessionTimes.includes(
                      slot.fromTimeResolved.split(" ").join("") +
                        "-" +
                        slot.toTimeResolved.split(" ").join("")
                    ) &&
                    sessionChangeCounter < 1) ||
                  (!slot.fromTimeResolved &&
                    initialValuesSessionTimes.includes(slot.notes) &&
                    sessionChangeCounter < 1)
                ) {
                  slot.isSelected = true;
                }
              });
              return pickedValue;
            } else {
              return Object.assign({}, prev, { slots: filteredResponse });
            }
          });
        }
        if (key === "session3") {
          setSession3((prev) => {
            let initialSessionsValues = props.input.value;
            if (initialSessionsValues?.length) {
              let theFirstSession = initialSessionsValues[0];
              let theSecondSession;
              let theThirdSession;

              for (let i = 0; i < initialSessionsValues.length; ++i) {
                if (initialSessionsValues[i].id !== theFirstSession.id) {
                  if (
                    theSecondSession &&
                    initialSessionsValues[i].id !== theSecondSession.id
                  ) {
                    theThirdSession = initialSessionsValues[i];
                  } else {
                    theSecondSession = initialSessionsValues[i];
                  }
                }
              }

              let firsSessionSlots = [];
              let secondSessionSlots = [];
              let thirdSessionSlots = [];
              initialSessionsValues.forEach((slot) => {
                if (slot.id === theFirstSession.id) {
                  firsSessionSlots.push(slot);
                }
                if (theSecondSession && slot.id === theSecondSession.id) {
                  secondSessionSlots.push(slot);
                }
                if (theThirdSession && slot.id === theThirdSession.id) {
                  thirdSessionSlots.push(slot);
                }
              });

              initialSessionsValues = [
                firsSessionSlots,
                secondSessionSlots,
                thirdSessionSlots,
              ];

              initialSessionsValues.forEach((item) => {
                if (item === undefined || item.length === 0) {
                  initialSessionsValues.splice(
                    initialSessionsValues.indexOf(item),
                    1
                  );
                }
              });
            }
            if (initialSessionsValues[2]) {
              let pickedValue = Object.assign({}, prev, { slots: filteredResponse });
              let initialValuesSessionTimes = [];
              if (Array.isArray(initialSessionsValues[2])) {
                initialSessionsValues[2].forEach((session) => {
                  if (session.sessiontime) {
                    initialValuesSessionTimes.push(
                      session.sessiontime.split(" ").splice(5, 6).join("")
                    );
                  } else if (!session.sessiontime && session.notes) {
                    initialValuesSessionTimes.push(session.notes);
                  }
                });
              } else {
                initialValuesSessionTimes.push(
                  initialSessionsValues[2].sessiontime
                    .split(" ")
                    .splice(5, 6)
                    .join("")
                );
              }
              pickedValue.slots.forEach((slot) => {
                if (!slot.fromTimeResolved && slot.fromTime) {
                  const array = slot.fromTime.split(":");
                  array.splice(array.indexOf("00"), 1);
                  slot.fromTimeResolved = array.join(":");
                }
                if (
                  (slot.fromTimeResolved &&
                    initialValuesSessionTimes.includes(
                      slot.fromTimeResolved.split(" ").join("") +
                        "-" +
                        slot.toTimeResolved.split(" ").join("")
                    ) &&
                    sessionChangeCounter < 1) ||
                  (!slot.fromTimeResolved &&
                    initialValuesSessionTimes.includes(slot.notes) &&
                    sessionChangeCounter < 1)
                ) {
                  slot.isSelected = true;
                }
              });
              return pickedValue;
            } else {
              return Object.assign({}, prev, { slots: filteredResponse });
            }
          });
        }
      })
      .catch();
  };

  const countSelected = (session) => {
    let counter = 0;
    for (let slot of session.slots) {
      if (slot.isSelected) {
        ++counter;
      }
    }
    return counter;
  };

  const sortTimes = (arr) => {
    let fullSlots = [];
    let sortedDates = arr.slice().sort(function (a, b) {
      return (
        new Date("1970/01/01 " + a.fromTimeResolved) -
        new Date("1970/01/01 " + b.fromTimeResolved)
      );
    });

    sortedDates.forEach((date) => {
      if (isNotAvailableSlot(date)) {
        fullSlots.push(date);
      }
    });

    fullSlots.forEach((fullSlot) => {
      sortedDates.splice(sortedDates.indexOf(fullSlot), 1);
    });

    sortedDates.push.apply(sortedDates, fullSlots);

    return sortedDates;
  };

  const isNotAvailableSlot = (slot) => {
    return slot.registered >= slot.maxStudent || slot.maxStudent === 0;
  };

  const isSessionFull = (session) => {
    if (session.variant === 'AM') return session.isAmFull === true;
    if (session.variant === 'PM') return session.isPmFull === true;
    return session.isSessionFull === true;
  };

  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const sortSessions = (arr) => {
    for (let item of arr) {
      if (item.fromDate === null) {
        arr.splice(arr.indexOf(item), 1);
        arr.unshift(item);
      }
    }

    sessions = arr;
  };

  sortSessions(sessions);

  const formatDateDay = (o) => {
    let day = String(new Date(o.fromDate).getDate());
    if (day.length === 1) {
      day = "0" + day;
    }
    return day;
  };

  const formatEndDateDay = (o) => {
    let day = String(new Date(o.toDate).getDate());
    if (day.length === 1) {
      day = "0" + day;
    }
    return day;
  };

  sessions = sessions.filter(function (item, pos) {
    return sessions.indexOf(item) == pos;
  });

  sessions.sort(function (a, b) {
    if (a.waitList && !b.waitList) return -1;
    if (!a.waitList && b.waitList) return 1;
    return a.fromDate < b.fromDate ? -1 : a.fromDate > b.fromDate ? 1 : 0;
  });

  const renderSessionOption = (o) => {
    const full = isSessionFull(o);
    let label;
    const suffix = full && o.variant ? `(${o.variant} - Session Full)`
                 : full ? '(Session Full)'
                 : o.variant ? `(${o.variant})`
                 : '';
    if (o.fromDate && o.toDate) {
      const dateRange = `${months[new Date(o.fromDate).getMonth()]} ${formatDateDay(o)} - ${months[new Date(o.toDate).getMonth()]} ${formatEndDateDay(o)}`;
      label = `${dateRange} ${o.location}${suffix ? ` ${suffix}` : ''}`;
    } else {
      const loc = o.location || "** " + o + " Classes **";
      label = `${loc}${suffix ? ` ${suffix}` : ''}`;
    }
    return (
      <option
        key={o.optionId || o.id || o}
        className="session-selector-text"
        disabled={checkIsSelected(o.optionId || o.id || o)}
        value={o.optionId || o.id || o}
      >
        {label}
      </option>
    );
  };

  const renderSessionOptions = () => {
    const waitlistSessions = sessions.filter(s => s.waitList);
    const regularSessions = sessions.filter(s => !s.waitList);
    if (waitlistSessions.length === 0) {
      return regularSessions.map(renderSessionOption);
    }
    return (
      <>
        <optgroup label="Waitlist:">
          {waitlistSessions.map(renderSessionOption)}
        </optgroup>
        {regularSessions.length > 0 && (
          <optgroup label="Sessions:">
            {regularSessions.map(renderSessionOption)}
          </optgroup>
        )}
      </>
    );
  };

  const renderPreference = (num, session, setSession, sessionError) => (
    <div className="d-flex flex-column col-lg-4">
      <div className="d-flex flex-column">
        <label>Session Preference #{num}</label>
        <select name={`session${num}`} className={sessionError ? 'picked' : ''} value={session?.optionId} onChange={valueChange}>
          <optgroup label="Options:">
            <option className="session-selector-text" value={undefined}>
              -Please select a location-
            </option>
            <option className="session-selector-text text-red" value={null}>
              -Clear-
            </option>
          </optgroup>
          {renderSessionOptions()}
        </select>
        {sessionError && (
          <span className={"validation-error mt-2"}>
            At least one choice per preference is required. If a preference no
            longer works for you, select -Clear- from the top of this dropdown
            menu, and leave blank.
          </span>
        )}
      </div>
      {session?.id && session.waitList && session.waitListMsg && (
        <div className="mt-3 details-wrapper waitlist-callout">
          <span>{session.waitListMsg}</span>
        </div>
      )}
      {session?.id && session.notes && (
        <div className="mt-3 details-wrapper">
          <span className="text-red">{session.notes}</span>
        </div>
      )}

      {session?.slots?.length > 0 && (
        <div className="mt-3 details-wrapper">
          <div>
            <div>
              <div className="d-flex justify-content-between text-uppercase">
                <h2 className="text-primary">Times selected</h2>
                <h2 className="text-primary">({countSelected(session)})</h2>
              </div>
              {sortTimes(session.slots)
                .filter((el) => el.isSelected === true)
                .map((slot) => (
                  <SlotOption
                    slot={slot}
                    session={session}
                    setSession={setSession}
                    isSelected={true}
                  />
                ))}
            </div>
            <div>
              <div className="d-flex justify-content-between text-uppercase">
                <h2 className="text-primary">Times not-selected</h2>
                <h2 className="text-primary">
                  ({session.slots.length - countSelected(session)})
                </h2>
              </div>
              {sortTimes(session.slots)
                .filter((el) => !el.isSelected)
                .map((slot) => (
                  <SlotOption
                    slot={slot}
                    session={session}
                    setSession={setSession}
                    isSelected={false}
                  />
                ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );

  return (
    <div className="d-flex row">
      {renderPreference(1, session1, setSession1, sessionError1)}
      {renderPreference(2, session2, setSession2, sessionError2)}
      {renderPreference(3, session3, setSession3, sessionError3)}
    </div>
  );
};

export default SessionField;
